import Icon from 'components/Icon';
import Spinner from 'components/Loaders/Spinner';
import {forwardRef, HTMLAttributes} from 'react';
import {twMerge} from 'tailwind-merge';

export const Placeholder = forwardRef<
    HTMLDivElement,
    HTMLAttributes<HTMLDivElement>
>(({children, ...props}, ref) => (
    <div
        className="flex aspect-[1/1.4142] animate-pulse items-center justify-center rounded bg-grey-200"
        ref={ref}
        {...props}
    >
        {children}
    </div>
));
Placeholder.displayName = 'Placeholder';

export const PlaceholderImage = forwardRef<
    HTMLDivElement,
    HTMLAttributes<HTMLDivElement>
>(({className, ...props}, ref) => (
    <Placeholder ref={ref} {...props}>
        <span className={twMerge('text-grey-500', className)}>
            <Spinner />
        </span>
    </Placeholder>
));
PlaceholderImage.displayName = 'PlaceholderImage';

export const ErrorImage = forwardRef<
    HTMLDivElement,
    HTMLAttributes<HTMLDivElement>
>(({className, ...props}, ref) => (
    <Placeholder ref={ref} {...props}>
        <span className={twMerge('text-coral-500', className)}>
            <Icon icon="error_solid" />
        </span>
    </Placeholder>
));
ErrorImage.displayName = 'ErrorImage';
